module.exports = __webpack_public_path__ + "8d900263b4c591b3f650e92ad466a205.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/checked.png
// module id = 56
// module chunks = 0